import { render, staticRenderFns } from "./Lgpd.vue?vue&type=template&id=504715ba"
import script from "./Lgpd.vue?vue&type=script&lang=js"
export * from "./Lgpd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports